import { render, staticRenderFns } from "./PsOpenMenuButton.vue?vue&type=template&id=5a536e1c&scoped=true&"
import script from "./PsOpenMenuButton.vue?vue&type=script&lang=js&"
export * from "./PsOpenMenuButton.vue?vue&type=script&lang=js&"
import style0 from "./PsOpenMenuButton.vue?vue&type=style&index=0&id=5a536e1c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a536e1c",
  null
  
)

export default component.exports